import styled from 'styled-components'
import { Button } from 'reactstrap'

import { media } from '../style-utils'

export const OptionView = styled.div`
    text-align: center;
    display: ${props => (!props.fullWidth ? 'inline-' : '')}block;
    margin-bottom: ${props => (props.fullWidth ? '20px' : '0')};    
`

export const OptionButton = styled(Button)`
    min-width: 120px;
    font-size: 1.3rem;
    margin-right: 10px;
    box-shadow: none !important;
`

export const OptionButtonSuccess = OptionButton.extend`
    ${media.tablet`
        :hover {
            background-color: transparent;
            color: #28a745;
            
            // animation: imitateClickSuccess 0.15s 1;
        }
    `}
`

export const OptionButtonDanger = OptionButton.extend`
    ${media.tablet`
        :hover {
            background-color: transparent;
            color: #dc3545;
        
            // animation: imitateClickDanger 0.15s 1;
        }
    `}
`

export const OptionButtonSecondary = OptionButton.extend`
    ${media.tablet`
        :hover {
            background-color: transparent;
            color: #6c757d;

            // animation: imitateClickSecondary 0.15s 1;
        }
    `}
`



// WEBPACK FOOTER //
// ./src/components/StyledComponents/IntroQuestions/Option.js